module.exports = __webpack_public_path__ + "img/Group1556238322@3x.4da97046.png";